import { toSnakeCase } from '../string/to-snake-case'

/**
 * Converts all keys of an object to snake_case.
 * Returns a new object with the same values but snake_case keys.
 * Does not mutate the input object.
 */
export function objectKeysToSnakeCase<T extends Record<string, any>>(obj: T): Record<string, any> {
  return Object.entries(obj).reduce(
    (acc, [key, value]) => {
      acc[toSnakeCase(key)] = value
      return acc
    },
    {} as Record<string, any>
  )
}
